<template>
  <div class="core">
    <div class="layui-layer-title" style="cursor: move">{{ title }}</div>
    <div class="layui-layer-content">
      <div class="layui-layer-wrap">
        <div class="form-collapse">
          <div class="info">
            <layui-form
              ref="mdForm"
              :show-form="true"
              :after-save="handleAfterSave"
              :rule="service_form_rule"
              :requestUniqueId="requestId"
            >
              <template slot-scope="{ scope }">
                <div class="layui-form">
                  <template>
                    <layui-collapse>
                      <div class="layui-colla-item">
                        <h2 class="layui-colla-title">门店基本信息</h2>
                        <div class="layui-colla-content layui-show">
                          <div class="layui-form-item-two">
                            <div class="layui-form-item-left">
                              <div class="pub-form">
                                <div class="layui-form-item">
                                  <label class="layui-form-label"><span class="x-red">*</span>客户名称： </label>
                                  <div class="layui-input-inline" style="width: 51%">
                                    <layui-multiselect
                                      :single="true"
                                      ref="clientSelect"
                                      :enabled="!isBrowserStatus"
                                      name="CLIENT_ID"
                                      @selectChange="clientChange($event)"
                                      table-name="YW_CUSTOMER_CLIENT"
                                      text-field="CLIENT_NAME"
                                      value-field="CLIENT_ID"
                                      :show-null-option="true"
                                      :enable-search="true"
                                      v-model="config.form.CLIENT_ID"
                                    ></layui-multiselect>
                                  </div>
                                  <span v-if="!isBrowserStatus" class="project-inner-add" @click="addClient()">
                                    <i class="layui-icon layui-icon-add-circle" style="color: #00a0e9"></i>
                                    新增
                                  </span>
                                </div>

                                <div class="layui-form-item">
                                  <label class="layui-form-label"><span class="x-red">*</span>品牌名称： </label>
                                  <div class="layui-input-inline" style="width: 51%">
                                    <layui-multiselect
                                      :single="true"
                                      ref="brandSelect"
                                      :enabled="!isBrowserStatus"
                                      name="BRAND_ID"
                                      @selectChange="brandChange($event)"
                                      table-name="YW_BRAND_DETAIL_V"
                                      text-field="BRAND_NAME"
                                      value-field="BRAND_ID"
                                      :show-null-option="true"
                                      :enable-search="true"
                                      v-model="config.form.BRAND_ID"
                                    ></layui-multiselect>
                                  </div>
                                  <span v-if="!isBrowserStatus" class="project-inner-add" @click="addBrand()">
                                    <i class="layui-icon layui-icon-add-circle" style="color: #00a0e9"></i>
                                    新增
                                  </span>
                                </div>

                                <div class="layui-form-item" v-if="formType == 'edit'">
                                  <label class="layui-form-label">门店编号： </label>
                                  <div class="layui-input-inline" style="width: 60%">
                                    <input
                                      type="text"
                                      :disabled="isBrowserStatus"
                                      v-model="config.form.STORE_BH"
                                      autocomplete="off"
                                      class="layui-input layui-disabled"
                                      name="STORE_BH"
                                      placeholder="请输入门店编号"
                                    />
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label"> <span class="x-red">*</span>门店名称： </label>
                                  <div class="layui-input-inline" style="width: 60%">
                                    <input
                                      type="text"
                                      :disabled="isBrowserStatus"
                                      v-model="config.form.STORE_NAME"
                                      autocomplete="off"
                                      :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                      name="STORE_NAME"
                                      placeholder="请输入门店名称"
                                    />
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">店长名称： </label>
                                  <div class="layui-input-inline" style="width: 51%">
                                    <layui-multiselect
                                      :single="true"
                                      ref="storeManagerSelectRef"
                                      :enabled="!isBrowserStatus"
                                      name="STORE_MANAGER_ID"
                                      @selectChange="storeManagerOnChange($event)"
                                      table-name="YW_STORE_MANAGER"
                                      text-field="STORE_MANAGER_NAME"
                                      value-field="STORE_MANAGER_ID"
                                      :show-null-option="true"
                                      :enable-search="true"
                                      v-model="config.form.STORE_MANAGER_ID"
                                    />
                                  </div>

                                  <span
                                    v-if="!isBrowserStatus"
                                    class="project-inner-add"
                                    @click="addStoreManagerOnClick()"
                                  >
                                    <i class="layui-icon layui-icon-add-circle" style="color: #00a0e9"></i>
                                    新增
                                  </span>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label"><span class="x-red">*</span>门店电话： </label>
                                  <div class="layui-input-inline" style="width: 60%">
                                    <input
                                      :disabled="isBrowserStatus"
                                      type="text"
                                      v-model="config.form.STORE_MANAGER_PHONE"
                                      autocomplete="off"
                                      :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                      name="STORE_MANAGER_PHONE"
                                      placeholder="请输入门店电话"
                                    />
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">IT负责人： </label>
                                  <div class="layui-input-inline" style="width: 60%">
                                    <input
                                      type="text"
                                      :disabled="isBrowserStatus"
                                      v-model="config.form.STORE_IT"
                                      autocomplete="off"
                                      :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                      name="STORE_IT"
                                      placeholder="请输入IT负责人"
                                    />
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">IT联系电话： </label>
                                  <div class="layui-input-inline" style="width: 60%">
                                    <input
                                      type="text"
                                      :disabled="isBrowserStatus"
                                      v-model="config.form.STORE_IT_PHONE"
                                      autocomplete="off"
                                      :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                      name="STORE_IT_PHONE"
                                      placeholder="请输入IT联系电话"
                                    />
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label"><span class="x-red">*</span>所属地： </label>
                                  <div class="layui-input-inline" style="width: 60%">
                                    <region-select
                                      :enabled="!isBrowserStatus"
                                      ref="ssd"
                                      v-model="config.form.SSD"
                                      @change="change"
                                    ></region-select>
                                  </div>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label"><span class="x-red">*</span>地址： </label>
                                  <div class="layui-input-inline" style="width: 50%">
                                    <input
                                      type="text"
                                      :disabled="isBrowserStatus"
                                      v-model="config.form.ADDRESS"
                                      autocomplete="off"
                                      :class="isBrowserStatus ? 'layui-input layui-disabled' : 'layui-input'"
                                      name="ADDRESS"
                                      placeholder="请输入地址"
                                    />
                                  </div>
                                  <button
                                    v-if="!isBrowserStatus"
                                    class="layui-btn"
                                    title="搜索"
                                    @click="searchAddress()"
                                  >
                                    搜 索
                                  </button>
                                </div>
                                <div class="layui-form-item">
                                  <label class="layui-form-label">备注： </label>
                                  <div class="layui-input-inline" style="width: 60%">
                                    <textarea
                                      v-model="config.form.BZ"
                                      :disabled="isBrowserStatus"
                                      autocomplete="off"
                                      :class="isBrowserStatus ? 'layui-textarea layui-disabled' : 'layui-textarea'"
                                      name="BZ"
                                      placeholder="请输入备注"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="layui-form-item-right" style="position: relative">
                              <div
                                id="container"
                                style="width: 100%; height: calc(100% - 20px); border: 1px solid #333"
                              ></div>
                              <div id="panel"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </layui-collapse>
                  </template>
                </div>
                <div class="layui-form-btn">
                  <div class="layui-footer">
                    <button class="layui-btn refresh" title="关闭" @click="handleBtnclick('close')">关 闭</button>
                    <button class="layui-btn" v-if="!isBrowserStatus" title="保存" @click="handleBtnclick('save')">
                      保 存
                    </button>
                  </div>
                </div>
              </template>
            </layui-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      requestId: 'CustomerStoreRequest',
      service_form_rule: {
        CLIENT_ID: {
          required: { message: '客户名称不能为空' }
        },
        BRAND_ID: {
          required: { message: '品牌名称不能为空' }
        },
        STORE_NAME: {
          required: { message: '门店名称不能为空' }
        },
        STORE_MANAGER_PHONE: {
          required: { message: '联系电话不能为空' }
        },
        SSD: {
          required: { message: '所属地不能为空' }
        },
        ADDRESS: {
          required: { message: '地址不能为空' }
        }
      },
      config: {
        form: {}
      },
      areaArr: [], // 地区码
      areaArrText: [], // 地区名
      formData: {},
      formType: 'add',
      title: '',
      map: null,
      placeSearch: null,
      marker: null,
      isBrowserStatus: false
    }
  },
  mounted() {
    this.AMapInit()
    if (this.tabParam) {
      this.formData = this.tabParam.editRow
      this.tableObj = this.tabParam.tableObj
      this.formType = this.tabParam.formType
      this.title = this.tabParam.title
      if (this.formType === 'edit') {
        if (!Array.isArray(this.formData.SSD)) {
          this.formData.SSD = this.formData.SSD.split(',')

          if (!this.formData.SSD[this.formData.SSD.length - 1]) {
            this.formData.SSD.pop()
          }
        }
        this.config.form = this.formData
        this.areaArrText.push(this.config.form.CITY_DESC)
        if (this.formData.LNG && this.formData.LAT) {
          var arriveCoor = []
          arriveCoor.push(this.formData.LNG)
          arriveCoor.push(this.formData.LAT)
          this.addMarker(arriveCoor)
        }
      } else {
        if (!Array.isArray(this.formData.SSD)) {
          this.formData.SSD = this.formData.SSD.split(',')

          if (!this.formData.SSD[this.formData.SSD.length - 1]) {
            this.formData.SSD.pop()
          }
        }
        this.config.form = this.formData
        this.areaArrText.push(this.config.form.CITY_DESC)
        if (this.formData.LNG && this.formData.LAT) {
          var arriveCoor = []
          arriveCoor.push(this.formData.LNG)
          arriveCoor.push(this.formData.LAT)
          this.addMarker(arriveCoor)
        }
        this.isBrowserStatus = true
      }
    }
  },
  methods: {
    change(val, fn) {
      let arr = []
      let arrText = []
      fn.forEach(item => {
        arr.push(item.id)
        arrText.push(item.text)
      })
      this.areaArr = arr
      this.areaArrText = arrText
      this.config.form.PROVINCE = this.areaArr[0] ? this.areaArr[0] : ''
      this.config.form.CITY = this.areaArr[1] ? this.areaArr[1] : ''
      this.config.form.DISTRICT = this.areaArr[2] ? this.areaArr[2] : ''
      if (this.areaArr[2] !== undefined) {
        this.$refs.ssd.$children[0].dropDownVisible = false
      }
    },
    addClient() {
      this.baseComponent.smartLoadComponent('clientForm', {
        tableObj: this.tableObj,
        formType: 'add',
        title: '新增客户',
        from: 'storeForm'
      })
    },
    addBrand() {
      this.baseComponent.smartLoadComponent('brandAddForm', {
        tableObj: this.tableObj,
        formType: 'add',
        title: '新增品牌',
        from: 'storeForm'
      })
    },
    addStoreManagerOnClick() {
      this.baseComponent.smartLoadComponent('storeManagerMngForm', {
        tableObj: this.tableObj,
        formType: 'add',
        title: '新增店长',
        from: 'storeForm'
      })
    },
    handleAfterSave() {
      this.baseComponent.closeComponent(this.tabParam.cloneMenu)
      if (this.tabParam.from == 'serviceRequestForm') {
        this.$bus.$emit('serviceRequest_inner_addStore')
        this.baseComponent.currentComponent = this.tabParam.sourceMenu
      } else {
        this.baseComponent.loadComponentByName('store')
        if (this.tableObj) {
          this.tableObj.pageInfo.pageIndex = 1
          this.tableObj.load()
        }
      }
    },
    // 和上面的change方法重复啊
    // change(val, fn) {
    //   let arr = []
    //   let arrText = []
    //   fn.forEach(item => {
    //     arr.push(item.id)
    //     arrText.push(item.text)
    //   })
    //   this.areaArr = arr
    //   this.areaArrText = arrText
    // },
    /**
     * 保存、关闭
     */
    handleBtnclick(type) {
      switch (type) {
        case 'close': {
          this.baseComponent.closeComponent(this.tabParam.cloneMenu)
          if (this.tabParam.from == 'serviceRequestForm') {
            this.baseComponent.currentComponent = this.tabParam.sourceMenu
          } else if (this.tabParam.from == 'storeManagerMngForm') {
            this.baseComponent.loadComponentByName('storeManagerMngForm')
          } else {
            this.baseComponent.loadComponentByName('store')
          }
          break
        }
        case 'save': {
          let arr = null
          if (this.config.form.SSD) {
            // arr = this.config.form.SSD.split(',');
            // this.config.form.PROVINCE = arr[0];
            // this.config.form.CITY = arr[1];
            // this.config.form.DISTRICT = arr[2];
            this.config.form.PROVINCE = this.config.form.SSD[0] ? this.config.form.SSD[0] : ''
            this.config.form.CITY = this.config.form.SSD[1] ? this.config.form.SSD[1] : ''
            this.config.form.DISTRICT = this.config.form.SSD[2] ? this.config.form.SSD[2] : ''
          } else {
            layer.msg('所属地不能为空', { icon: 5, shift: 6 })
          }
          this.$refs.mdForm.editRow = this.config.form

          if (this.$refs.mdForm.validate()) {
            //判断是否选择了位置
           
            this.$refs.mdForm.callableSave('YW_CUSTOMER_STORE')
          }
          break
        }
        default: {
          break
        }
      }
    },
    //品牌下拉
    // renderText(row) {
    //   if (row) {
    //     if (row['CLIENT_NAME']) {
    //       return '客户【' + row['CLIENT_NAME'] + '】品牌【' + row['BRAND_NAME'] + '】'
    //     } else {
    //       return row['BRAND_NAME']
    //     }
    //   }
    // },
    storeManagerOnChange(selectData) {
      if (selectData != null && selectData.length > 0) {
        this.config.form['STORE_MANAGER_ID'] = selectData[0].value
        this.config.form['STORE_MANAGER'] = selectData[0].name
      } else {
        this.config.form['STORE_MANAGER_ID'] = ''
        this.config.form['STORE_MANAGER'] = ''
      }
    },
    //客户变化
    clientChange(data) {
      if (data.length > 0) {
        this.$refs.brandSelect.queryCondition.CLIENT_ID = data[0]._row.CLIENT_ID
        this.$refs.brandSelect.refreshAsyncData()
      } else {
        this.$refs.brandSelect.queryCondition.CLIENT_ID = ''
        this.$refs.brandSelect.refreshAsyncData()
      }
    },
    //品牌变化
    brandChange(data) {
      if (data.length > 0) {
        this.config.form['BRAND_NAME_'] = data[0]._row.BRAND_NAME
        this.config.form['CLIENT_NAME_'] = data[0]._row.CLIENT_NAME
        //this.$refs.clientSelect.queryCondition.CLIENT_ID = data.CLIENT_ID;
        //this.$refs.clientSelect.refreshAsyncData();
        this.config.form.CLIENT_ID = data[0]._row.CLIENT_ID
      } else {
        this.config.form.CLIENT_ID = ''
        this.$refs.brandSelect.queryCondition.CLIENT_ID = ''
        this.$refs.brandSelect.refreshAsyncData()
      }
    },
    //初始化地图
    AMapInit() {
      this.map = new AMap.Map('container', {
        resizeEnable: true,
        zoom: 10
      })
      //鹰眼
      this.map.addControl(new AMap.OverView())
      //比例尺
      this.map.addControl(new AMap.Scale())
      //工具条
      this.map.addControl(new AMap.ToolBar())
      AMap.service(['AMap.PlaceSearch'], () => {
        //构造地点查询类
        this.placeSearch = new AMap.PlaceSearch({
          pageSize: 5, // 单页显示结果条数
          pageIndex: 1, // 页码
          citylimit: true, //是否强制限制在设置的城市内搜索
          map: this.map, // 展现结果的地图实例
          panel: 'panel', // 结果列表将在此容器中进行展示。
          autoFitView: true, // 是否自动调整地图视野使绘制的 Marker点都处于视口的可见范围
          renderStyle: 'default'
        })
        // 添加列表点选监听事件
        AMap.event.addListener(this.placeSearch, 'selectChanged', this.selectAddress)
      })
    },
    //搜索
    searchAddress() {
      if (!this.config.form.ADDRESS) {
        this.layer.openAlert('请输入地址', false)
        return
      }
      // 根据选择政区过滤
      // var zq = this.$refs.ssd.zqSelectText.split("-");
      // 依据ssd来查询area然后拼接到city中去
      var zq = this.areaArrText
      if (!zq || zq.length === 0) {
        this.layer.openAlert('请选择所属地', false)
        return
      }

      var city = zq.length > 2 ? zq[2] : zq.length > 1 ? zq[1] : zq.length == 1 ? zq[0] : '全国'
      this.placeSearch.setCity(city)
      // this.placeSearch.search(this.config.form.ADDRESS)

      this.placeSearch.search(this.config.form.ADDRESS, (status, result) => {
        if (status === 'complete') {
          if (result.poiList.pois.length === 0) {
            this.layer.openAlert('没有查询到对应的地址', false)
          } else {
            let lng = result.poiList.pois[0].location.lng
            let lat = result.poiList.pois[0].location.lat
          }
        } else if (status === 'no_data') {
          this.layer.openAlert('没有查询到对应的地址', false)
        }
      })
    },
    selectAddress(e) {
      //这里获得点选地点的经纬度
      let location = e.selected.data.location
      this.config.form['LNG'] = location.lng
      this.config.form['LAT'] = location.lat
    },
    // 实例化点标记
    addMarker(arriveCoor) {
      this.marker = new AMap.Marker({
        icon: '', //图片ip
        imageSize: '20px',
        position: arriveCoor,
        offset: new AMap.Pixel(-13, -30),
        // 设置是否可以拖拽
        draggable: false,
        cursor: 'move',
        // 设置拖拽效果
        raiseOnDrag: false
      })
      this.marker.setMap(this.map)
      this.map.setFitView()
      //监听拖拽结束事件
      AMap.event.addListener(this.marker, 'dragend', this.dragendFun)
    },
    dragendFun(e) {
      this.config.form['LNG'] = e.lnglat.lng
      this.config.form['LAT'] = e.lnglat.lat
    }
  }
}
</script>
<style scoped>
#panel {
  position: absolute;
  background-color: white;
  max-height: 80%;
  overflow-y: auto;
  top: 10px;
  left: 10px;
  width: 250px;
}
.layui-input-inline >>> .layui-form-select dl {
  max-height: 224px;
  z-index: 999999;
}
.client-select-style xm-select {
}

.client-select-style > xm-select {
}

.client-select-style >>> xm-select {
}
</style>



// WEBPACK FOOTER //
// src/components/person/storeManage/storeForm.vue